import { EventSystem, IEventSystem } from "@dhx/ts-common/events";
import { SelectionEvents, ISelection, ISelectionConfig, Id } from "@dhx/ts-common/types";
import { DataCollection } from "./datacollection";
import { DataEvents } from "./types";

export class Selection implements ISelection {
	public events: IEventSystem<SelectionEvents>;
	public config: ISelectionConfig;

	private _selected: Id;
	private _data: DataCollection;

	constructor(config: ISelectionConfig, data?: DataCollection, events?: IEventSystem<any>) {
		this.events = events || new EventSystem<any>(this);
		this._data = data;
		this.config = config;

		this._data.events.on(DataEvents.removeAll, () => {
			this._selected = null;
		});
		this._data.events.on(DataEvents.change, () => {
			if (this._selected) {
				const near = this._data.getNearId(this._selected);
				if (near !== this._selected) {
					this._selected = null;
					if (near) {
						this.add(near);
					}
				}
			}
		});
	}

	getId(): Id {
		return this._selected;
	}

	getItem(): any {
		if (this._selected) {
			return this._data.getItem(this._selected);
		}
		return null;
	}

	remove(id?: Id): boolean {
		id = id || this._selected;
		if (!id) {
			return true;
		}
		if (this.events.fire(SelectionEvents.beforeUnSelect, [id])) {
			this._data.update(id, { $selected: false }, true);
			this._selected = null;
			this.events.fire(SelectionEvents.afterUnSelect, [id]);
			return true;
		}
		return false;
	}

	add(id: Id): void {
		if (this._selected === id || !!this.config.disabled || !this._data.exists(id)) {
			return;
		}
		this.remove();

		this._addSingle(id);
	}

	enable(): void {
		this.config.disabled = false;
	}

	disable(): void {
		this.remove();
		this.config.disabled = true;
	}

	private _addSingle(id: Id) {
		if (this.events.fire(SelectionEvents.beforeSelect, [id])) {
			this._selected = id;
			this._data.update(id, { $selected: true }, true);
			this.events.fire(SelectionEvents.afterSelect, [id]);
		}
	}
}
